import React, { useEffect, useState } from "react";
import "./About.css";
import "../../i18n";
import { useTranslation } from "react-i18next";
import {
  newIT,
  newITL,
  games,
  gamesL,
  football,
  footballL,
  fishing,
  fishingL,
} from "../../assets/";

const About = () => {
  const { t } = useTranslation();
  const [isLightMode, setIsLightMode] = useState(false);

  const updateTheme = () => {
    const currentTheme = document.documentElement.getAttribute("data-theme");
    setIsLightMode(currentTheme === "light");
  };

  useEffect(() => {
    updateTheme();

    const observer = new MutationObserver(() => {
      updateTheme();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="aboutme" id="about">
      <div className="wrapper">
        <div className="name">
          <p>{t("aboutMe")}</p>
        </div>
        <div className="main">
          <section className="first">
            <p>{t("about1")}</p>
            <p>{t("about2")}</p>
            <p>{t("about3")}</p>
            <p>{t("about4")}</p>
          </section>
          <section className="second">
            <div className="box" id="box2">
              <img
                src={isLightMode ? gamesL : games}
                alt="Gry"
                className="icon"
              />
              <div className="tooltip">{t("interest2")}</div>
            </div>
            <div className="box" id="box1">
              <img
                src={isLightMode ? newITL : newIT}
                alt="newIT"
                className="icon"
              />
              <div className="tooltip">{t("interest1")}</div>
            </div>
            <div className="box" id="box3">
              <img
                src={isLightMode ? footballL : football}
                alt="Piłka Nożna"
                className="icon"
              />
              <div className="tooltip">{t("interest3")}</div>
            </div>
            <div className="box" id="box4">
              <img
                src={isLightMode ? fishingL : fishing}
                alt="Wędkarstwo"
                className="icon"
              />
              <div className="tooltip">{t("interest4")}</div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
